
import { CheckCircle, AlertCircle, Clock, Database } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

interface FAQSyncStatusProps {
  sentToFrank?: boolean;
  sentAt?: string;
  syncErrorMessage?: string;
  lastSyncAttempt?: string;
  frankSyncAttempts?: number;
}

export const FAQSyncStatus = ({ 
  sentToFrank, 
  sentAt, 
  syncErrorMessage, 
  lastSyncAttempt,
  frankSyncAttempts 
}: FAQSyncStatusProps) => {
  const getSyncStatus = () => {
    if (sentToFrank && sentAt) {
      return {
        icon: <CheckCircle className="h-3 w-3" />,
        label: "Synced",
        variant: "default" as const,
        tooltip: `Successfully synced to Frank on ${new Date(sentAt).toLocaleString()}`
      };
    }

    if (syncErrorMessage) {
      return {
        icon: <AlertCircle className="h-3 w-3" />,
        label: "Sync Error",
        variant: "destructive" as const,
        tooltip: `Sync failed: ${syncErrorMessage}${frankSyncAttempts ? ` (${frankSyncAttempts} attempts)` : ''}`
      };
    }

    if (lastSyncAttempt) {
      return {
        icon: <Clock className="h-3 w-3" />,
        label: "Pending",
        variant: "secondary" as const,
        tooltip: `Last sync attempt: ${new Date(lastSyncAttempt).toLocaleString()}`
      };
    }

    return {
      icon: <Database className="h-3 w-3" />,
      label: "Local Only",
      variant: "outline" as const,
      tooltip: "Not synced to Frank AI"
    };
  };

  const status = getSyncStatus();

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Badge variant={status.variant} className="text-xs flex items-center gap-1">
            {status.icon}
            {status.label}
          </Badge>
        </TooltipTrigger>
        <TooltipContent>
          <p>{status.tooltip}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
